import React from 'react';
import type { MemberRole, MemberType } from '@/types/client';
import { MEMBER_TYPE_LABELS } from '@/types/client';

interface MemberRoleSelectProps {
  value: MemberRole;
  onChange: (value: MemberRole) => void;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  excludeRoles?: MemberRole[];
}

export const MemberRoleSelect: React.FC<MemberRoleSelectProps> = ({
  value,
  onChange,
  disabled = false,
  className = '',
  required = false,
  excludeRoles = [],
}) => {
  // Nouveaux types de membres
  const allMemberTypes: MemberType[] = ['employe', 'comptable', 'responsable', 'gerant'];
  const memberRoles = allMemberTypes.filter(role => !excludeRoles.includes(role));
  
  console.log('[DEBUG] MemberRoleSelect - excludeRoles:', excludeRoles);
  console.log('[DEBUG] MemberRoleSelect - filtered memberRoles:', memberRoles);

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as MemberRole)}
      disabled={disabled}
      required={required}
      className={`
        w-full px-3 py-2 border border-gray-300 rounded-lg
        focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500
        disabled:bg-gray-100 disabled:cursor-not-allowed
        dark:bg-gray-800 dark:border-gray-600 dark:text-white
        ${className}
      `}
    >
      {memberRoles.map((role) => (
        <option key={role} value={role}>
          {MEMBER_TYPE_LABELS[role]}
        </option>
      ))}
    </select>
  );
};

export default MemberRoleSelect;
